<template>
	<div>
		<Clist :pShowBtnAdd="false" :ShowBusqueda="false" :ShowFilas="false" :regresar="false" @FiltrarC="GetServiceManagement" :Filtro="Filtro" :Nombre="NameList" :isModal="true" :Total="TotalPagina" :pConfigLoad="ConfigLoad">
			<template slot="Filtros">
				<div class="form-group mr-2">
					<label for="">Cliente</label>
				</div>
				<div class="form-group mr-2" style="max-width: 14rem">
					<treeselect
						@input="GetServiceManagement();GetListaSucursales();"
						:options="ListaClientes"
						placeholder="Busque un Cliente..."
						v-model="Filtro.IdCliente"
						:disable-fuzzy-matching="true"
					/>
				</div>
				<div class="form-group mr-2">
					<label for="">Propiedad</label>
				</div>
				<div class="form-group mr-2" style="max-width: 14rem">
					<treeselect
						@input="GetServiceManagement();GetListaNumContratos()"
						:options="ListaSucursales"
						placeholder="Busque una Propiedad..."
						v-model="Filtro.IdClienteS"
						:disable-fuzzy-matching="true"
					/>
				</div>
				<div class="form-group mr-2">
					<label for="">Contrato</label>
				</div>
				<div class="form-group mr-2" style="max-width: 23rem">
					<treeselect
						@input="GetServiceManagement()"
						:options="ListaContratos"
						placeholder="Busque un Contrato..."
						v-model="Filtro.IdContrato"
						:disable-fuzzy-matching="true"
					/>
				</div>
				<div class="form-group mr-2">
					<label for="">Tipo de Servicio</label>
					<select @change="GetServiceManagement()" v-model="Filtro.IdConfigS" name="" id="" class="ml-2 form-control">
						<!-- <option value="">- Tipo de Servicio -</option>
						<option value="1">Mantenimiento</option>
						<option value="2">Servicio</option> -->
						<option value="3">Proyecto</option>
					</select>
				</div>
				<div class="form-group mr-2">
					<label for="">Año</label>
					<select @change="GetServiceManagement()" v-model="Filtro.Anio" name="" id="" class="ml-2 form-control">
						<option value="">- Año -</option>
						<option v-for="(item,index) in ListaAnios" :value="item" :key="index">{{item}}</option>
					</select>
				</div>
				<div class="form-group mr-2">
					<label for="">Estatus</label>
					<select @change="GetServiceManagement()" v-model="Filtro.EstatusContrato" name="" id="" class="ml-2 form-control">
						<option value="">- Estatus -</option>
						<option value="Activo">Activo</option>
						<option value="Inactivo">Inactivo</option>
						<option value="Terminado">Terminado</option>
					</select>
				</div>
			</template>
			<template slot="header">
				<tr>
					<th>No. Contrato</th>
					<th>Cliente</th>
					<th>Propiedad</th>
					<th class="text-center">Materiales</th>
					<th class="text-center">Equipos</th>
					<th class="text-center">Mano Obra</th>
					<th class="text-center">Vehiculos</th>
					<th class="text-center">Contratistas</th>
					<th class="text-center">Viáticos</th>
					<th class="text-center">Burden</th>
					<th class="text-center">GP Plan</th>
					<th class="text-center">GP Actual</th>
					<th class="text-center">Venta</th>
					<th class="text-center">Facturado</th>
					<th class="text-center">Cobrado</th>
					<th>Estatus</th>
				</tr>
			</template>
			<template slot="body">
				<tr v-for="(item,key,index) in ListaServiceManagement" :key="index" :class="EvalGPClass(item)">
					<td v-b-tooltip.hover.top :title="item.NumeroC">{{$limitCharacters(item.NumeroC,13)}}</td>
					<td v-b-tooltip.hover.top :title="item.Cliente">{{$limitCharacters(item.Cliente,20)}}</td>
					<td v-b-tooltip.hover.top :title="item.Propiedad">{{$limitCharacters(item.Propiedad,20)}}</td>
					<td class="text-center">$ {{isNaN(parseInt(item.MontoActualMateriales)) ? 0 : formateoMillon(parseInt(item.MontoActualMateriales))}}</td>
					<td class="text-center">$ {{isNaN(parseInt(item.MontoActualEquipos)) ? 0 : formateoMillon(parseInt(item.MontoActualEquipos))}}</td>
					<td class="text-center">$ {{isNaN(parseInt(item.MontoActualMaObra)) ? 0 : formateoMillon(parseInt(item.MontoActualMaObra))}}</td>
					<td class="text-center">$ {{isNaN(parseInt(item.MontoActualVehiculos)) ? 0 : formateoMillon(parseInt(item.MontoActualVehiculos))}}</td>
					<td class="text-center">$ {{isNaN(parseInt(item.MontoActualContratistas)) ? 0 : formateoMillon(parseInt(item.MontoActualContratistas))}}</td>
					<td class="text-center">$ {{isNaN(parseInt(item.MontoActualViaticos)) ? 0 : formateoMillon(parseInt(item.MontoActualViaticos))}}</td>
					<td class="text-center">$ {{isNaN(parseInt(item.MontoActualBurden)) ? 0 : formateoMillon(parseInt(item.MontoActualBurden))}}</td>
					<!-- <td class="text-center">$ {{isNaN(parseInt(item.GrossProfitPlan)) ? 0 : formateoMillon(parseInt(item.GrossProfitPlan))}}</td> -->
					<td class="text-center">{{isNaN(parseInt(item.GrossProfitPlanPorcen)) ? 0 : parseInt(item.GrossProfitPlanPorcen)}} %</td>
					<!-- <td class="text-center">$ {{isNaN(parseInt(item.GrossProfitActual)) ? 0 : formateoMillon(parseInt(item.GrossProfitActual))}}</td> -->
					<td class="text-center">{{isNaN(parseInt(item.GrossProfitActualPorcen)) ? 0 : parseInt(item.GrossProfitActualPorcen)}} %</td>
					<td class="text-center bold">$ {{isNaN(parseInt(item.FacturacionPMensual)) ? 0 : formateoMillon(parseInt(item.FacturacionPMensual))}}</td>
					<td class="text-center bold">$ {{isNaN(parseInt(item.Facturacion)) ? 0 : formateoMillon(parseInt(item.Facturacion))}}</td>
					<td :class="'text-center bold '+EvalCuentaColor(item)">$ {{isNaN(parseInt(item.MontoCobrado)) ? 0 : formateoMillon(parseInt(item.MontoCobrado))}}</td>
					<td>{{item.Estatus}}</td>
				</tr>
			</template>
		</Clist>
	</div>
</template>

<script>
import Clist from "@/components/Clist.vue";
import Cbtnaccion from "@/components/Cbtnaccion.vue";
import CSinRegistros from "@/components/CSinRegistros.vue";
export default {
	name:'servicemanagement',
	components:{
        Clist,
        Cbtnaccion,
        CSinRegistros,
    },
	data() {
		return {
			NameList:"Análisis Financiero Proyectos",
			FormName:'projectmanagement',
			Pag:0,
            TotalPagina:2,
			Filtro:{
                Nombre:"",
                Placeholder:"Cliente / Propiedad...",
                TotalItem:0,
                Pagina:1,
                Entrada:20,
				IdConfigS:'3',
				IdTipoSer:'',
				Mes:'',
				Anio:'',
				IdCliente:null,
				IdClienteS:null,
				IdContrato:null,
				EstatusContrato:'Activo'
            },
			ConfigLoad:{
	    		ShowLoader:true,
	    		ClassLoad:true,
	    	},
			ListaServiceManagement:[],
			ListaAnios:[],
			ListaClientes:[],
			ListaSucursales:[],
			ListaContratos:[]
		}
	},
	methods: {
		async GetServiceManagement(){
			this.ConfigLoad.ShowLoader=true;
			await this.$http.get('servicemanagement/get',{
				params:{
					Nombre:this.Filtro.Nombre,
                    Entrada:this.Filtro.Entrada,
                    pag:this.Filtro.Pagina,
					IdConfigS:this.Filtro.IdConfigS,
					Anio:this.Filtro.Anio,
					IdCliente:this.Filtro.IdCliente,
					IdClienteS:this.Filtro.IdClienteS,
					IdContrato:this.Filtro.IdContrato,
					EstatusContrato:this.Filtro.EstatusContrato
				}
			}).then((res)=>{
				this.ListaServiceManagement=res.data.data.servicemanagement;
				this.Filtro.Entrada=res.data.data.pagination.PageSize;
                this.Filtro.TotalItem=res.data.data.pagination.TotalItems;
			}).finally(()=>{
				this.ConfigLoad.ShowLoader=false;
			})
		},
		async GetAnios(){
			await this.$http.get("funciones/getanios").then(res => {
				//console.log('Calling Years');
				this.ListaAnios = res.data.ListaAnios;
				this.Filtro.Anio = res.data.AnioActual;
				this.GetServiceManagement();
			});
		},
		GetListaClientes(){
			this.$http.get("clientessimple/get",{
				params:{
					Tipo:'Cliente'
				}
			}
			).then((res)=>{
				this.ListaClientes=res.data.data.clientes.map(function(obj){
					return {id:obj.IdCliente,label:obj.Nombre}
				})
			});
		},
		GetListaSucursales(){
			this.Filtro.IdClienteS=null;
			this.Filtro.IdContrato=null;
			this.$http.get("clientesucursal/get",{
				params:{
					Todos:true,
					RegEstatus:'A',
					IdCliente:this.Filtro.IdCliente
				}
			}
			).then((res)=>{
				this.ListaSucursales=res.data.data.sucursal.map(function(obj){
					return {id:obj.IdClienteS,label:obj.Nombre}
				});
			});
		},
		GetListaNumContratos(){
			this.Filtro.IdContrato=null;
			this.$http.get("numcontrato/get",{
				params:{
					IdClienteS:this.Filtro.IdClienteS
				}
			}).then((res)=>{
				this.ListaContratos=res.data.data.contractlist.map(function(obj){
					return {id:obj.IdContrato,label:obj.NumeroC}
				})
			})
		},
		formateoMillon(num,digits=1){
            const units = [
        { value: 1E12, symbol: 'T' },
        { value: 1E9, symbol: 'B' },
        { value: 1E6, symbol: 'M' },
        // { value: 1E3, symbol: 'K' }
    ];
    for (let i = 0; i < units.length; i++) {
        if (num >= units[i].value) {
            const raw = num / units[i].value;
            const factor = Math.pow(10, digits);
            const truncated = Math.floor(raw * factor) / factor;
            const formatted = new Intl.NumberFormat('es-MX', {
                minimumFractionDigits: digits,
                maximumFractionDigits: digits
            }).format(truncated);
			return formatted + units[i].symbol;

        }
    }
	return new Intl.NumberFormat('es-Mx').format(num);
        },
		EvalGPClass(item){
			let MontoActualMateriales=item.MontoActualMateriales==null ? 0 : item.MontoActualMateriales;
			let MontoActualEquipos=item.MontoActualEquipos==null ? 0 : item.MontoActualEquipos;
			let MontoActualMaObra=item.MontoActualMaObra==null ? 0 : item.MontoActualMaObra;
			let MontoActualVehiculos=item.MontoActualVehiculos==null ? 0 : item.MontoActualVehiculos;
			let MontoActualContratistas=item.MontoActualContratistas==null ? 0 : item.MontoActualContratistas;
			let MontoActualViaticos=item.MontoActualViaticos==null ? 0 : item.MontoActualViaticos;
			let MontoActualBurden=item.MontoActualBurden==null ? 0 : item.MontoActualBurden;
			let Facturacion=item.Facturacion==null ? 0 : item.Facturacion;
			let FacturacionPMensual=item.FacturacionPMensual==null ? 0 : item.FacturacionPMensual;
			let GPMenos5=parseInt(item.GrossProfitPlanPorcen)-5;
			if (GPMenos5<0) {
				GPMenos5=0;
			}
			if ((MontoActualMateriales == 0 && MontoActualEquipos == 0 && MontoActualMaObra==0 && MontoActualVehiculos==0 && MontoActualContratistas==0 && MontoActualViaticos==0 && MontoActualBurden==0 && Facturacion==0) || FacturacionPMensual==0) {
				return '';
			}
			// if (FacturacionPMensual==0) {
			// 	return '';
			// }
			if (item.GrossProfitActualPorcen<GPMenos5) {
				return 'bg-danger-lite';
			}
			else if (item.GrossProfitActualPorcen>=GPMenos5 && item.GrossProfitActualPorcen<item.GrossProfitPlanPorcen) {
				return 'bg-warning-lite';
			}
			else{
				return 'bg-success-lite';
			}
		},
		EvalCuentaColor(item){
			let GPMenos5=item.GrossProfitPlanPorcen-5;
			if (GPMenos5<0) {
				GPMenos5=0;
			}
			if (item.GrossProfitPlanPorcen!=0 && (item.MontoCobrado==0 || item.MontoCobrado<item.FacturacionPMensual)) {
				if (item.GrossProfitActualPorcen<GPMenos5) {
					return '';
				}
				else{
					return 'color-red-lite';
				}
			}
		}
	},
	created() {
		this.GetListaClientes();	
	},
	mounted() {
		this.GetAnios();
	},
}
</script>

<style>

</style>
